(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cancel-order"] && !window.DesignMode) return;
  try {
    
document.getElementById('cancel-order-button').addEventListener('click', function() {
  document.getElementById('issue-cancel-popup').classList.remove('hidden');
});

document.getElementById('close-cancel-popup').addEventListener('click', function() {
  document.getElementById('issue-cancel-popup').classList.add('hidden');
});

  document.getElementById('custom-coupon-code').addEventListener('click', function() {
    var couponCode = document.getElementById('coupon-code').textContent;
    navigator.clipboard.writeText(couponCode).then(function() {
        document.getElementById('custom-coupon-code').style.display = 'none';
        document.getElementById('coupon-display').style.display = 'block';
    }).catch(function(err) {
        console.error('Could not copy text: ', err);
    });
});


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["features-slider"] && !window.DesignMode) return;
  try {
    
$(document).ready(function(){
      $('.anarc-featured-card-slider').slick({
        slidesToShow: 3,
        slidesToScroll: 1,
        arrows: true,
        dots: false,
        speed: 300,
        infinite: true,
        // autoplaySpeed: 5000,
        // autoplay: true,
        prevArrow: $('.f-slider-prev-btn'),
        nextArrow: $('.f-slider-next-btn'),
         responsive: [
           {
        breakpoint: 1200,
        settings: {
          slidesToShow: 2,
         }
      },
      {
        breakpoint: 991,
        settings: {
          slidesToShow: 3,
         }
      },
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 2,
         }
      },
      {
        breakpoint: 500,
        settings: {
          slidesToShow: 1,
         }
      },
    ]
      });
    });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["image-only-slider"] && !window.DesignMode) return;
  try {
    
$(document).ready(function(){
      $('.image-only-slider').slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false,
        dots: true,
        // speed: 300,
        // infinite: true,
        autoplaySpeed: 5000,
        autoplay: true,
         responsive: [
            
    ]
      });
    });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["my-order"] && !window.DesignMode) return;
  try {
    
document.getElementById('submit-order-issue').addEventListener('click', function() {
  var orderNumber = document.getElementById('order-number').value.trim();
  var issueDropdown = document.getElementById('order-issue');
  var selectedValue = issueDropdown.value;

  if (orderNumber === '') {
    alert('Please enter your order number.');
    return;
  }
  if (selectedValue === '') {
    alert('Please select an issue.');
    return;
  }
  if (selectedValue === 'cancel-order') {
    window.location.href = '/pages/cancel-order';
  } else {
    document.getElementById('issue-popup').classList.remove('hidden');
  }
});
document.getElementById('close-popup').addEventListener('click', function() {
  document.getElementById('issue-popup').classList.add('hidden');
});

  
  } catch(e) { console.error(e); }
})();
})();
